import React, { useEffect, useState } from 'react';
import Seo from '../../../Components/SeoComponent/Seo';
import Header from '../../../Components/Header';
import { Button, InputWithLabel } from '../../../Components/Tags/Tags';
import Loader from '../../../Loader';
import { fetchProfile, itrComplinceCheckService } from '../../../Services/ApiTestService/aadharTestService';
import { showErrorToast, showSuccessToast } from '../../../utils/toastUtils';
import { Link } from "react-router-dom";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { useService } from '../../../context/ServiceContext';

import {
    FaIdCard,
    FaCalendarCheck,
    FaLink,
    FaCheckCircle,
    FaExclamationTriangle,
    FaUserSecret,
    FaRegAddressCard,
    FaPrint,
    FaCopy
} from "react-icons/fa"
import { itrComplinceData } from '../Data';
import { handlePrint } from '../../../utils';




const ItrComplinceCheck = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [panNumber, setPanNumber] = useState('');
    const [message, setMessage] = useState({ message: "", type: "error" });
    const [profileData, setProfileData] = useState({});
    const [itrData, setItrData] = useState(null);
    const { serviceName } = useService();
    async function handleSubmit() {
        // var regpan = /^([a-zA-Z])([0-9])([a-zA-Z])?$/;
        var regpan = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

        if (panNumber === "") {
            setMessage({ message: "Pan Number is required required.", type: "error" });
            return;
        }
        if (!regpan.test(panNumber)) {
            setMessage({ message: "Invalid Pan Number.", type: "error" });
            return;
        }
        // return;
        setIsLoading(true);
        try {
            setMessage({ message: "Verifying Pan...", type: "success" });
            const payload = {
                api_id: profileData?.user_id,
                api_key: profileData?.api_key,
                token_id: profileData?.token_id,
                pan_number: panNumber
            };
            let response = await itrComplinceCheckService({ payload });

            if (response.status.code === 200) {
                setIsLoading(false);
                showSuccessToast(response.message);
                setMessage({ message: response?.message, type: "success" });
                setItrData(response.data);
                setPanNumber('');
            } else {
                setIsLoading(false);
                showErrorToast(response.message || response.data.message || response.error.message || "Something went wrong.");
                setMessage({ message: "Something went wrong. Please try again.", type: "error" });
            }
        } catch (error) {
            setIsLoading(false);
            setMessage({ message: "Something went wrong. Please try again.", type: "error" });
        }
    }

    useEffect(() => {
        const fetchProfileData = async () => {
            try {
                setIsLoading(true);
                const response = await fetchProfile();
                setProfileData(response.data);
            } catch (error) {
                console.error("Error fetching profile data:", error);
                showErrorToast("Failed to fetch profile data.");
            } finally {
                setIsLoading(false);
            }
        };

        fetchProfileData();
    }, []);





    const renderCompanyCard = () => {



        return (
            <div id="company-card" className="relative bg-white/80 backdrop-blur-lg border border-blue-200 p-6 rounded-2xl shadow-2xl max-w-2xl mx-auto transition-all duration-300 hover:shadow-3xl hover:scale-[1.01]">

             


                {/* Print Button */}
                <div
                    onClick={() => handlePrint("company-card")}
                    className="absolute top-4 right-0 w-10 h-10 bg-blue-700 rounded-full shadow-inner flex justify-center items-center cursor-pointer hover:bg-blue-500 transition-colors">
                    <FaPrint className="text-white text-xl" />
                </div>



                <div className="mb-4 flex items-center gap-3">
                    <FaIdCard className="text-blue-700 text-2xl" />
                    <h2 className="text-2xl font-semibold text-blue-900">
                        {itrData?.pan_number || "Client ID Not Available"}
                    </h2>
                </div>

                <div className="text-gray-800 text-sm space-y-3">

                    <p className="flex items-center gap-2">
                        <FaIdCard className="text-indigo-500" />
                        <strong>PAN Number:</strong> {itrData?.pan_number || "N/A"}
                    </p>

                    <p className="flex items-center gap-2">
                        <FaCalendarCheck className="text-green-600" />
                        <strong>PAN Allotment Date:</strong> {itrData?.pan_allotment_date || "N/A"}
                    </p>

                    <p className="flex items-center gap-2">
                        <FaLink className="text-blue-500" />
                        <strong>PAN-Aadhaar Link:</strong> {itrData?.pan_aadhaar_linked || "N/A"}
                    </p>

                    <p className="flex items-center gap-2">
                        <FaCheckCircle className="text-green-600" />
                        <strong>Compliant:</strong> {itrData?.compliant ? "true" : "false" || "N/A"}
                    </p>

                    <p className="flex items-center gap-2">
                        <FaExclamationTriangle className="text-yellow-600" />
                        <strong>Specified Person Under 206:</strong> {itrData?.specified_person_under_206 || "N/A"}
                    </p>

                    <p className="flex items-center gap-2">
                        <FaUserSecret className="text-gray-600" />
                        <strong>Masked Name:</strong> {itrData?.masked_name || "Not Provided"}
                    </p>

                    <p className="flex items-center gap-2">
                        <FaRegAddressCard className="text-purple-600" />
                        <strong>PAN Status:</strong> {itrData?.pan_status || "Not Available"}
                    </p>

                </div>
            </div>
        );
    };

    function handleCopyText(data) {
        window.navigator.clipboard.writeText(JSON.stringify(data));
        showSuccessToast('Copied successfully')
    }






    return (
        <div className="p-4">
            <Seo title={serviceName} />
            <Header heading={serviceName} />
            {isLoading && <Loader />}

                  
                  <div className="col-span-2 md:col-span-6 flex justify-end">
              <Link
                to="/TestMaster"
                className="flex items-center gap-1 text-white bg-green-600 hover:bg-green-700 px-1 py-1 rounded-md font-semibold shadow-md transition duration-300"
              >
                <span>Go Back</span>
                <IoArrowBackCircleOutline size={24} />
              </Link>
            </div>

            <div className='flex items-end gap-2'>
                <div>
                    <InputWithLabel
                        label={"Pan "}
                        placeholder={"Enter pan number."}
                        required={true}
                        value={panNumber}
                        DivclassName={'uppercase'}

                        onChange={(e) => setPanNumber(e.target.value)}
                    />
                    <span className={`${message.type === "error" ? 'text-red-800' : 'text-green-500'} `}>{message.message}</span>
                </div>
                <Button text={'Verify'} type={'button'} onClick={handleSubmit} />
            </div>

            {itrData && (
                <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>{renderCompanyCard()}</div>
                    <pre className="bg-black relative text-green-500 p-4 rounded text-sm overflow-auto max-h-[600px]">
                    <FaCopy className="absolute top-2 cursor-pointer right-2  bg-white p-1 rounded-md font-bold text-2xl" onClick={()=>handleCopyText(itrData)} />
                        {JSON.stringify(itrData, null, 2)}
                    </pre>
                </div>
            )}
        </div>
    );
};

export default ItrComplinceCheck;
